<script>
    /*
        users/UserEditModal
    */
    import R, {LOADER} from "../../lib/requests";
    import ControlLoader from "../ControlLoader.svelte";

    export let transporters = null;
    export let transporterId = 0;
    export let placeholder = null;
    export let id = '';

    let loading = false;

    const initialize = () => {
        if (transporters == null) {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            transporters = result;
            loading = false;
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.transporter.index, {}, onSuccess, onFailure);
    }

    initialize();
</script>

<div class="position-relative">
    <select class="form-select" id="{id}" bind:value={transporterId}>
        {#if placeholder}
            <option value="0" disabled selected>{ placeholder }</option>
        {/if}
        {#if transporters}
            {#each transporters as item}
                <option value="{ item.id }">{ item.name }</option>
            {/each}
        {/if}
    </select>
    <ControlLoader {loading} displayLeft/>
</div>
